import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-xs sm:text-sm text-gray-400 font-medium mt-6" data-id="element-261">
      <div className="flex items-center gap-1.5" data-id="element-262">
        <ShieldCheckIcon className="w-4 h-4 text-padel-lime" data-id="element-263" />
        <span data-id="element-264">Garantía 7 días</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-265">
        <LockIcon className="w-4 h-4 text-padel-lime" data-id="element-266" />
        <span data-id="element-267">Pago seguro</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-268">
        <ZapIcon className="w-4 h-4 text-padel-lime" data-id="element-269" />
        <span data-id="element-270">Acceso en 5 minutos</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-271">
        <CreditCardIcon className="w-4 h-4 text-padel-lime" data-id="element-272" />
        <span data-id="element-273">Mercado Pago — Tarjeta — Transferencia</span>
      </div>
    </div>;
}